import { Component, OnInit, ChangeDetectorRef, Input, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// PrimeNG Imports (Apenas os que não dão erro)
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ModalWrapperModule } from 'src/app/shared/components/modal-wrapper/modal-wrapper.module';

@Component({
  selector: 'app-text-area-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    TooltipModule,
    ModalWrapperModule,
  ],
  templateUrl: './text-area-modal.component.html',
  styleUrls: ['./text-area-modal.component.scss'],
})
export class TextAreaModalComponent implements OnInit, AfterViewInit {
  @Input() title: string = 'Edit Remark';
  @Input() text: string = '';
  @Input() instructionName?: string;
  @Input() onOpenInstruction?: () => void;
  @Input() showSaveButton: boolean = true; // <-- Nova variável adicionada
  @Input('onTextChange') onTextChangeCallback?: (text: string) => void;

  private initialText = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // Quando usado com PrimeNG DialogService, as opções chegam em config.data.
    if (this.config?.data) {
      const d = this.config.data as any;
      if (d.title) this.title = d.title;
      this.text = d.text ?? this.text;
      this.instructionName = d.instructionName ?? this.instructionName;
      this.onOpenInstruction = d.onOpenInstruction ?? this.onOpenInstruction;
      this.showSaveButton = d.showSaveButton ?? this.showSaveButton;
      this.onTextChangeCallback = d.onTextChange ?? this.onTextChangeCallback;
    }

    this.initialText = this.text;
  }

  /** Only the Save flow (no live onTextChange callback) has something to lose on close —
   *  the other callers already apply every keystroke to the parent model as-you-type. */
  get isDirty(): boolean {
    return this.showSaveButton && !this.onTextChangeCallback && this.text !== this.initialText;
  }

  ngAfterViewInit(): void {
    // Em fluxos onde o chamador configura inputs via componentInstance (NgbModal),
    // garantir que a view receba as mudanças.
    try {
      this.cdr.detectChanges();
    } catch {}
  }

  openInstruction(): void {
    this.onOpenInstruction?.();
  }

  onSave(): void {
    this.ref.close(this.text);
  }

  onTextChange(newValue: string) {
    this.text = newValue;

    if (this.onTextChangeCallback) {
      try {
        this.onTextChangeCallback(newValue);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('onTextChange callback error', err);
      }
    }

    // Garante que o template do modal atualize imediatamente
    try {
      this.cdr.detectChanges();
    } catch {}
  }

  onCancel(): void {
    this.ref.close();
  }
}